<script lang="ts">
	export let replaceText: (text: string, prec: string, iso: boolean, local: boolean) => string;
	export let handleClickCopy: () => void;

	let precision = "secs"
	let iso = false;
	let local = true;

	let inputText = "[1600701105] 秒単位\n[1600801105123] ミリ秒単位\n[1600901105123456] マイクロ秒単位\n[1601001105123456789] ナノ秒単位\n[1601101105.123456] 小数点付き"
	let outputText = "";
	function handleClickReplace() {
		outputText = replaceText(inputText, precision, iso, local);
	}
</script>

<main>
	<h1>タイムスタンプを日付文字列に置換</h1>
	<h2>
		<a href="/app/string-timestamp-converter/">逆バージョンはこちら</a>
	</h2>
	<h2>説明</h2>
	<p>
		2001年9月9日以降のタイムスタンプっぽい数字を見つけたら、それをわかりやすい文字列に置換してくれるよ。<br>
		ログファイルを貼り付けて置換してみよう！！<br>
		<a href="/posts/timestamp-converter/">作ってみたときのブログ記事はこちら</a>
	</p>
	<p>
		<input type="radio" bind:group={precision} value={"secs"}> 秒精度
		<input type="radio" bind:group={precision} value={"millis"}> ミリ秒精度
		<input type="radio" bind:group={precision} value={"micros"}> マイクロ秒精度
		<input type="radio" bind:group={precision} value={"nanos"}> ナノ秒精度
	</p>
	<p>
		<input type="checkbox" bind:checked={iso}> ISOフォーマット
		<input type="checkbox" bind:checked={local}> ローカル時間
	</p>
	<p>
		<textarea id="input-text" cols="120" rows="10" bind:value={inputText}></textarea>
	</p>
	<p>
		<button on:click={handleClickReplace}>置換する</button>
		<button on:click={handleClickCopy}>コピーする</button>
	</p>
	<p>
		<textarea id="output-text" cols="120" rows="10" readonly bind:value={outputText}></textarea>
	</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	textarea {
		max-width: 100%;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>